__turbopack_context__.v({
  "anatomyIndex": "grass-atlas-module__Y1r6PG__anatomyIndex",
  "anatomyIndexActive": "grass-atlas-module__Y1r6PG__anatomyIndexActive",
  "anatomyPrompt": "grass-atlas-module__Y1r6PG__anatomyPrompt",
  "answerGood": "grass-atlas-module__Y1r6PG__answerGood",
  "answerTryAgain": "grass-atlas-module__Y1r6PG__answerTryAgain",
  "atlas-fade-up": "grass-atlas-module__Y1r6PG__atlas-fade-up",
  "atlas-grass-burst": "grass-atlas-module__Y1r6PG__atlas-grass-burst",
  "atlas-loading": "grass-atlas-module__Y1r6PG__atlas-loading",
  "atlas-sheet-up": "grass-atlas-module__Y1r6PG__atlas-sheet-up",
  "atlasFrame": "grass-atlas-module__Y1r6PG__atlasFrame",
  "atlasGrid": "grass-atlas-module__Y1r6PG__atlasGrid",
  "atlasToolbar": "grass-atlas-module__Y1r6PG__atlasToolbar",
  "blades": "grass-atlas-module__Y1r6PG__blades",
  "broadBlades": "grass-atlas-module__Y1r6PG__broadBlades",
  "compactChecklist": "grass-atlas-module__Y1r6PG__compactChecklist",
  "compareGrid": "grass-atlas-module__Y1r6PG__compareGrid",
  "comparePicker": "grass-atlas-module__Y1r6PG__comparePicker",
  "compareRow": "grass-atlas-module__Y1r6PG__compareRow",
  "compareSources": "grass-atlas-module__Y1r6PG__compareSources",
  "compareTrust": "grass-atlas-module__Y1r6PG__compareTrust",
  "crown": "grass-atlas-module__Y1r6PG__crown",
  "desktopModeTabs": "grass-atlas-module__Y1r6PG__desktopModeTabs",
  "detailBackdrop": "grass-atlas-module__Y1r6PG__detailBackdrop",
  "detailHeader": "grass-atlas-module__Y1r6PG__detailHeader",
  "detailPanel": "grass-atlas-module__Y1r6PG__detailPanel",
  "dissected": "grass-atlas-module__Y1r6PG__dissected",
  "eyebrow": "grass-atlas-module__Y1r6PG__eyebrow",
  "facts": "grass-atlas-module__Y1r6PG__facts",
  "fieldReferenceBlock": "grass-atlas-module__Y1r6PG__fieldReferenceBlock",
  "fineBlades": "grass-atlas-module__Y1r6PG__fineBlades",
  "fingerprint": "grass-atlas-module__Y1r6PG__fingerprint",
  "focusMode": "grass-atlas-module__Y1r6PG__focusMode",
  "glossyBlades": "grass-atlas-module__Y1r6PG__glossyBlades",
  "grassBurst": "grass-atlas-module__Y1r6PG__grassBurst",
  "grassSelectField": "grass-atlas-module__Y1r6PG__grassSelectField",
  "guideAction": "grass-atlas-module__Y1r6PG__guideAction",
  "guideCopy": "grass-atlas-module__Y1r6PG__guideCopy",
  "guideIcon": "grass-atlas-module__Y1r6PG__guideIcon",
  "guideLink": "grass-atlas-module__Y1r6PG__guideLink",
  "hairyBlades": "grass-atlas-module__Y1r6PG__hairyBlades",
  "hotspot": "grass-atlas-module__Y1r6PG__hotspot",
  "hotspotActive": "grass-atlas-module__Y1r6PG__hotspotActive",
  "hotspots": "grass-atlas-module__Y1r6PG__hotspots",
  "intro": "grass-atlas-module__Y1r6PG__intro",
  "introKicker": "grass-atlas-module__Y1r6PG__introKicker",
  "library": "grass-atlas-module__Y1r6PG__library",
  "libraryHeading": "grass-atlas-module__Y1r6PG__libraryHeading",
  "libraryOpen": "grass-atlas-module__Y1r6PG__libraryOpen",
  "mixedBlades": "grass-atlas-module__Y1r6PG__mixedBlades",
  "mobileDetailOpen": "grass-atlas-module__Y1r6PG__mobileDetailOpen",
  "mobileFocusAction": "grass-atlas-module__Y1r6PG__mobileFocusAction",
  "mobileGrassChoice": "grass-atlas-module__Y1r6PG__mobileGrassChoice",
  "mobileModeTabs": "grass-atlas-module__Y1r6PG__mobileModeTabs",
  "mobileSheetClose": "grass-atlas-module__Y1r6PG__mobileSheetClose",
  "mobileSpeciesTrigger": "grass-atlas-module__Y1r6PG__mobileSpeciesTrigger",
  "modeActive": "grass-atlas-module__Y1r6PG__modeActive",
  "modeTabs": "grass-atlas-module__Y1r6PG__modeTabs",
  "modelEvidence": "grass-atlas-module__Y1r6PG__modelEvidence",
  "modelFallback": "grass-atlas-module__Y1r6PG__modelFallback",
  "modelFallbackNotice": "grass-atlas-module__Y1r6PG__modelFallbackNotice",
  "needleBlades": "grass-atlas-module__Y1r6PG__needleBlades",
  "noResults": "grass-atlas-module__Y1r6PG__noResults",
  "numberToggle": "grass-atlas-module__Y1r6PG__numberToggle",
  "pageShell": "grass-atlas-module__Y1r6PG__pageShell",
  "panelIntro": "grass-atlas-module__Y1r6PG__panelIntro",
  "panelTitle": "grass-atlas-module__Y1r6PG__panelTitle",
  "photoChecklist": "grass-atlas-module__Y1r6PG__photoChecklist",
  "prostrateBlades": "grass-atlas-module__Y1r6PG__prostrateBlades",
  "quizCorrect": "grass-atlas-module__Y1r6PG__quizCorrect",
  "quizFeedback": "grass-atlas-module__Y1r6PG__quizFeedback",
  "quizMeta": "grass-atlas-module__Y1r6PG__quizMeta",
  "quizNext": "grass-atlas-module__Y1r6PG__quizNext",
  "quizOptions": "grass-atlas-module__Y1r6PG__quizOptions",
  "quizProgress": "grass-atlas-module__Y1r6PG__quizProgress",
  "quizSelected": "grass-atlas-module__Y1r6PG__quizSelected",
  "quizWrong": "grass-atlas-module__Y1r6PG__quizWrong",
  "referenceDetails": "grass-atlas-module__Y1r6PG__referenceDetails",
  "referenceDetailsBody": "grass-atlas-module__Y1r6PG__referenceDetailsBody",
  "referencePhoto": "grass-atlas-module__Y1r6PG__referencePhoto",
  "referencePhotoFrame": "grass-atlas-module__Y1r6PG__referencePhotoFrame",
  "referenceThumbs": "grass-atlas-module__Y1r6PG__referenceThumbs",
  "referenceUnavailable": "grass-atlas-module__Y1r6PG__referenceUnavailable",
  "reviewStatus": "grass-atlas-module__Y1r6PG__reviewStatus",
  "rhizome": "grass-atlas-module__Y1r6PG__rhizome",
  "ridgedBlades": "grass-atlas-module__Y1r6PG__ridgedBlades",
  "roots": "grass-atlas-module__Y1r6PG__roots",
  "runners": "grass-atlas-module__Y1r6PG__runners",
  "runnersVisible": "grass-atlas-module__Y1r6PG__runnersVisible",
  "scaleNote": "grass-atlas-module__Y1r6PG__scaleNote",
  "searchField": "grass-atlas-module__Y1r6PG__searchField",
  "seedhead": "grass-atlas-module__Y1r6PG__seedhead",
  "selectedPart": "grass-atlas-module__Y1r6PG__selectedPart",
  "sheetBackdrop": "grass-atlas-module__Y1r6PG__sheetBackdrop",
  "simBoundary": "grass-atlas-module__Y1r6PG__simBoundary",
  "simCondition": "grass-atlas-module__Y1r6PG__simCondition",
  "simConditions": "grass-atlas-module__Y1r6PG__simConditions",
  "simPlayButton": "grass-atlas-module__Y1r6PG__simPlayButton",
  "simPlayer": "grass-atlas-module__Y1r6PG__simPlayer",
  "simPresets": "grass-atlas-module__Y1r6PG__simPresets",
  "simResponse": "grass-atlas-module__Y1r6PG__simResponse",
  "simTrendCard": "grass-atlas-module__Y1r6PG__simTrendCard",
  "simTrends": "grass-atlas-module__Y1r6PG__simTrends",
  "simulationPanel": "grass-atlas-module__Y1r6PG__simulationPanel",
  "soilLine": "grass-atlas-module__Y1r6PG__soilLine",
  "sourceLinks": "grass-atlas-module__Y1r6PG__sourceLinks",
  "speciesActive": "grass-atlas-module__Y1r6PG__speciesActive",
  "speciesLink": "grass-atlas-module__Y1r6PG__speciesLink",
  "speciesList": "grass-atlas-module__Y1r6PG__speciesList",
  "speciesMark": "grass-atlas-module__Y1r6PG__speciesMark",
  "specimen": "grass-atlas-module__Y1r6PG__specimen",
  "specimen-breathe": "grass-atlas-module__Y1r6PG__specimen-breathe",
  "specimen-lift": "grass-atlas-module__Y1r6PG__specimen-lift",
  "specimenCaption": "grass-atlas-module__Y1r6PG__specimenCaption",
  "specimenCue": "grass-atlas-module__Y1r6PG__specimenCue",
  "specimenRoot": "grass-atlas-module__Y1r6PG__specimenRoot",
  "specimenStage": "grass-atlas-module__Y1r6PG__specimenStage",
  "stems": "grass-atlas-module__Y1r6PG__stems",
  "summary": "grass-atlas-module__Y1r6PG__summary",
  "takeawayStrip": "grass-atlas-module__Y1r6PG__takeawayStrip",
  "threeAtmosphere": "grass-atlas-module__Y1r6PG__threeAtmosphere",
  "threeCanvas": "grass-atlas-module__Y1r6PG__threeCanvas",
  "threeFocusRail": "grass-atlas-module__Y1r6PG__threeFocusRail",
  "threeHotspot": "grass-atlas-module__Y1r6PG__threeHotspot",
  "threeHotspotActive": "grass-atlas-module__Y1r6PG__threeHotspotActive",
  "threeHotspots": "grass-atlas-module__Y1r6PG__threeHotspots",
  "threeInstructions": "grass-atlas-module__Y1r6PG__threeInstructions",
  "threeLoading": "grass-atlas-module__Y1r6PG__threeLoading",
  "threeModelBadge": "grass-atlas-module__Y1r6PG__threeModelBadge",
  "threeStage": "grass-atlas-module__Y1r6PG__threeStage",
  "tuftedBlades": "grass-atlas-module__Y1r6PG__tuftedBlades",
  "utilityActions": "grass-atlas-module__Y1r6PG__utilityActions",
  "verdict": "grass-atlas-module__Y1r6PG__verdict",
  "viewer": "grass-atlas-module__Y1r6PG__viewer",
  "viewerLabel": "grass-atlas-module__Y1r6PG__viewerLabel",
});
